import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { UserForm } from "@/components/register/UserForm";
import type { UserData } from "@/types/auth";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import { useAppSelector } from "@/hooks/useAppSelector";
import { registerRequest } from "@/store/slices/authSlice";

const Register = () => {
  const { toast } = useToast();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { loading, error, verificationPending } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (verificationPending) {
      navigate("/verify");
    }
  }, [verificationPending, navigate]);

  useEffect(() => {
    if (error?.error?.detail?.general) {
      toast({
        variant: "destructive",
        title: "Registration failed",
        description: error.error.detail.general[0],
      });
    }
  }, [error, toast]);

  const handleUserData = (data: UserData) => {
    dispatch(registerRequest(data));
  };

  return (
    <div className="container max-w-2xl mx-auto py-10 px-4">
      <div className="bg-white rounded-xl shadow-sm border border-slate-100 p-8">
        <h1 className="text-2xl font-bold mb-8 text-slate-900">Create an Account</h1>
        <UserForm 
          onNext={handleUserData} 
          apiError={error} 
          isLoading={loading} 
        />
      </div>
    </div>
  );
};

export default Register;